import { getAdditionalServicesOptions, getGearOptions, getLastDiveOptions } from './fieldHelpers';
// import { USER_GENDERS } from './userHelpers';
import { composeValidators, emailFormatValid, numberAtLeast, required } from './validators';

export const getSeatsFields = (intl, listing = null) => {
  const seatsFields = [
    {
      name: 'name',
      type: 'text',
      label: intl.formatMessage({ id: 'BookingDatesForm.seatsFirstName' }),
      validate: required(intl.formatMessage({ id: 'BookingDatesForm.seatsFirstNameRequired' })),
      locationPath: 'attributes.profile.firstName',
      otherProps: {
        type: 'text'
      },
    },
    {
      name: 'lastName',
      type: 'text',
      label: intl.formatMessage({ id: 'BookingDatesForm.seatsLastName' }),
      validate: required(intl.formatMessage({ id: 'BookingDatesForm.seatsLastNameRequired' })),
      locationPath: 'attributes.profile.lastName',
      otherProps: {
        type: 'text'
      },
    },
    /* {
      name: 'gender',
      type: 'select',
      label: intl.formatMessage({ id: 'BookingDatesForm.seatsGender' }),
      validate: required(intl.formatMessage({ id: 'BookingDatesForm.seatsGenderRequired' })),
      options: USER_GENDERS,
      keyLabel: 'value',
      otherProps: {
        type: 'select'
      },
    }, */
    {
      name: 'email',
      type: 'email',
      label: intl.formatMessage({ id: 'BookingDatesForm.seatsEmail' }),
      validate: emailFormatValid(intl.formatMessage({ id: 'BookingDatesForm.seatsEmailInvalid' })),
      locationPath: 'attributes.email',
      removeCapitalize: true,
      otherProps: {
        type: 'email'
      },
    },
    {
      name: 'experienceYears',
      type: 'number',
      label: intl.formatMessage({ id: 'BookingDatesForm.seatsExperienceYears' }),
      validate: composeValidators(
        required(intl.formatMessage({ id: 'BookingDatesForm.seatsExperienceYearsRequired' })),
        numberAtLeast(intl.formatMessage({ id: 'BookingDatesForm.seatsExperienceYearsValid' }), 0)
      ),
      locationPath: 'attributes.profile.publicData.experienceYears',
      otherProps: {
        type: 'number',
        min: 0,
      },
    },
    {
      name: 'birthdate',
      type: 'date',
      label: intl.formatMessage({ id: 'BookingDatesForm.seatsBirthdate' }),
      validate: required(intl.formatMessage({ id: 'BookingDatesForm.seatsBirthdateRequired' })),
      locationPath: 'attributes.profile.publicData.birthdate',
      placeholder: intl.formatMessage({ id: 'BookingDatesForm.seatsBirthdate' }),
      otherProps: {
        type: 'date',
        // placeholderText: intl.formatMessage({ id: 'BookingDatesForm.seatsBirthdate' }),
        // isOutsideRange: () => false,
        // yearSelector: true
      },
    },
    {
      name: 'lastDive',
      type: 'radio',
      label: intl.formatMessage({ id: 'BookingDatesForm.seatsLastDive' }),
      validate: required(intl.formatMessage({ id: 'BookingDatesForm.seatsLastDiveRequired' })),
      locationPath: 'attributes.profile.publicData.lastTimeOfDive',
      options: getLastDiveOptions(intl, false),
      keyLabel: 'value',
      printedLabel: 'printedLabel',
      otherProps: {
        // type: 'select'
      },
    },
    {
      name: 'gear',
      type: 'radio',
      label: intl.formatMessage({ id: 'BookingTimeForm.gearTitle' }),
      validate: required(intl.formatMessage({ id: 'BookingTimeForm.gearRequired' })),
      options: getGearOptions(intl, listing, false),
      keyLabel: 'value',
      showAsLabel: true,
      otherProps: {
        // type: 'select'
        onChange: (e) => {
          const wrapper = document.getElementById('fileInputWrapper');
          if (wrapper) {
            if (['full', 'partial'].includes(e)) {
              wrapper.style.display = 'unset';
            } else {
              wrapper.style.display = 'none';
            }
          }
        }
      },
    },
    {
      name: 'certificationCard',
      type: 'certificationCard',
      label: intl.formatMessage({ id: 'SignupForm.certificationCard' }),
      locationPath: 'attributes.profile.publicData.certificationCard',
      compareName: 'gear',
      visible: (gear) => {
        return ['full', 'partial'].includes(gear);
      },
      showAs: (value) => {
        if (value) {
          return intl.formatMessage({ id: 'BookingTimeForm.fileUploaded' });
        }

        return intl.formatMessage({ id: 'BookingTimeForm.pendingFile' });
      },
      otherProps: {
        label: intl.formatMessage({ id: 'SignupForm.certificationCard' }),
        updateLabel: intl.formatMessage({ id: 'SignupForm.certificationCardUpload' }),
        updatedLabel: intl.formatMessage({ id: 'SignupForm.certificationCardUploaded' }),
      }
    },
    {
      name: 'additionalServices',
      type: 'checkboxGroup',
      label: intl.formatMessage({ id: 'BookingTimeForm.additionalServicesLabel' }),
      options: getAdditionalServicesOptions(intl, listing),
      hideOnModal: true,
    }
  ];

  return seatsFields;
};
